<template>
  <div class="historyItem">
    <div class="leftSideBar"></div>
    <div class="historyContentBox">
      <h4 class="historyDate">{{historyItem.eventDate}}</h4>
      <strong class="historyTitle" :title="historyItem.title">{{historyItem.title}}</strong>
      <span class="historyContent" :title="historyItem.subTitle">{{historyItem.content}}</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "history-item",
        props:['historyItem']
    }
</script>

<style scoped lang="scss">
  @import "@/styles/Sunnyfactory.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/HistoryItem.vue